import React, { useEffect, useState } from "react";

export const MONTHS_IT = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];
const MONTHS_SHORT = ["gen","feb","mar","apr","mag","giu","lug","ago","set","ott","nov","dic"];

export function fmtDateIT(iso) {
  if (!iso) return "—";
  const [y, m, d] = String(iso).split("-").map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${MONTHS_IT[m - 1]} ${y}`;
}
export function fmtDateShort(iso) {
  if (!iso) return "—";
  const [y, m, d] = String(iso).split("-").map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${MONTHS_SHORT[m - 1]} ${y}`;
}

export function relTime(iso) {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "—";
  const diff = Math.max(Date.now() - then, 0);
  const min = Math.floor(diff / 60000);
  if (min < 1) return "adesso";
  if (min < 60) return `${min} min fa`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} h fa`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d} gg fa`;
  if (d < 30) return `${Math.floor(d / 7)} sett fa`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return `${mo} mesi fa`;
  return `${Math.floor(d / 365)} anni fa`;
}

export function initials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "—";
}

const AVATAR_TONES = [
  "bg-rose-50 text-rose-700", "bg-primary/15 text-primary", "bg-emerald-50 text-emerald-700",
  "bg-sky-50 text-sky-700", "bg-amber-50 text-amber-800", "bg-violet-50 text-violet-700",
];
export function Avatar({ name, unread, size = "md" }) {
  const idx = String(name || "").split("").reduce((a, ch) => a + ch.charCodeAt(0), 0) % AVATAR_TONES.length;
  const cls = unread ? "bg-rose-50 text-rose-700" : AVATAR_TONES[idx];
  const dim = size === "lg" ? "w-14 h-14 text-lg" : size === "sm" ? "w-8 h-8 text-[11px]" : "w-11 h-11 text-sm";
  return (
    <span className={`${dim} rounded-full inline-flex items-center justify-center font-medium shrink-0 ${cls}`}>
      {initials(name)}
    </span>
  );
}

export function StatusBadge({ c, className = "" }) {
  if (c?.is_unread_lead) {
    return (
      <span className={`inline-flex items-center px-2 h-6 rounded text-[11px] font-medium bg-rose-50 text-rose-700 border border-rose-100 whitespace-nowrap ${className}`} data-testid={`badge-new-${c.id}`}>
        Nuova richiesta
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center px-2 h-6 rounded text-[10px] font-semibold uppercase tracking-wider border whitespace-nowrap ${c?.workflow_status_class || ""} ${className}`} data-testid={`badge-${c?.id}`}>
      {c?.workflow_status_label || "—"}
    </span>
  );
}

export const SORT_OPTIONS = [
  { key: "wedding_date_asc", label: "Data più vicina" },
  { key: "wedding_date_desc", label: "Data più lontana" },
  { key: "activity_desc", label: "Attività più recente" },
  { key: "activity_asc", label: "Attività meno recente" },
  { key: "name_asc", label: "Nome A–Z" },
  { key: "name_desc", label: "Nome Z–A" },
  { key: "created_desc", label: "Ultima creazione" },
];

export const DATE_RANGE_OPTIONS = [
  { key: "all", label: "Tutte" },
  { key: "this_month", label: "Questo mese" },
  { key: "next_30", label: "Prossimi 30 giorni" },
  { key: "next_90", label: "Prossimi 90 giorni" },
  { key: "past", label: "Data passata" },
];

export const PAYMENT_OPTIONS = [
  { key: "all", label: "Tutti" },
  { key: "unpaid", label: "Non pagato" },
  { key: "deposit_received", label: "Acconto ricevuto" },
  { key: "partially_paid", label: "Parzialmente pagato" },
  { key: "paid", label: "Pagato" },
  { key: "balance_due", label: "Saldo da incassare" },
];

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => (typeof window !== "undefined" ? window.matchMedia(query).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

export function operatorsLabel(c) {
  const ops = c?.operators || [];
  if (!ops.length) return "Non assegnato";
  return ops.map((o) => o.name).join(", ");
}

export function contactLinks(c) {
  const digits = String(c?.phone || "").replace(/\D/g, "");
  return {
    wa: digits.length >= 8 ? `https://wa.me/${digits}` : null,
    mail: c?.email ? `mailto:${c.email}` : null,
  };
}
